import Avatar from './Avatar.vue'

export { Avatar }
export default Avatar
